import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './AffirmMessageA.module.scss';

const AffirmMessageA = (props) => {
  const { isAffirmEligible = false, price, style = {}, className } = props;

  return (
    isAffirmEligible
      ? <div
        className={classNames('affirm-as-low-as', classes.affirmMessage, className)}
        data-page-type='cart'
        data-amount={`${price * 100}`}
        style={style}
      /> : null
  );
};

AffirmMessageA.propTypes = {
  price: PropTypes.number,
  isAffirmEligible: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default AffirmMessageA;
